var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-checklist-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.checklistItems")))]),
        _vm._v(" "),
        _vm._l(_vm.localConfig.items, function (item, index) {
          return _c(
            "div",
            { key: "item-" + index, staticClass: "checklist-item" },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("taskModuleRules.itemTitle") },
                on: { change: _vm.emitChange },
                model: {
                  value: _vm.localConfig.items[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.localConfig.items, index, $$v)
                  },
                  expression: "localConfig.items[index]",
                },
              }),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "text", size: "small", danger: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeItem(index)
                    },
                  },
                },
                [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
              ),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c(
          "a-button",
          { attrs: { type: "dashed", block: "" }, on: { click: _vm.addItem } },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("taskModuleRules.addItem")) +
                "\n        "
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }